/**
 * Série du Défi du jour et joker (44 du TODO).
 *
 * Une série vit tant que le défi a été joué aujourd'hui ou hier. Le joker
 * couvre un jour manqué, au plus une fois par période de 7 jours : jouer
 * avant-hier puis aujourd'hui prolonge la série au lieu de la remettre à 1, et
 * le jour couvert est noté dans `jokerUsedDay`. Les jours sont des numéros de
 * jour du Défi (`DailyChallenge.dayNumberFor`), jamais des dates : aucun
 * piège de fuseau horaire.
 *
 * Miroir côté serveur : `server/src/daily/streak.js` (colonne « Série en
 * cours » du classement, onglet Activité de l'admin). Les deux doivent rester
 * identiques, voir `tests/streakRules.test.js`.
 */
export const JOKER_COOLDOWN_DAYS = 7;

export function jokerAvailableFor(streak, missedDay) {
	const used = streak?.jokerUsedDay;
	return !used || missedDay - used >= JOKER_COOLDOWN_DAYS;
}

export function isStreakAlive(streak, dayNumber) {
	if (!streak || !(streak.current > 0)) return false;
	const last = streak.lastPlayedDay ?? 0;
	if (last >= dayNumber - 1) return true;
	return last === dayNumber - 2 && jokerAvailableFor(streak, dayNumber - 1);
}

/**
 * Série après avoir joué le jour `dayNumber`. Idempotente pour un même jour.
 * @returns {{ streak: object, jokerUsed: boolean }}
 */
export function advanceStreak(streak, dayNumber) {
	const s = { lastPlayedDay: 0, current: 0, longest: 0, ...streak };
	if (s.lastPlayedDay === dayNumber) return { streak: s, jokerUsed: false };

	let jokerUsed = false;
	if (s.current > 0 && s.lastPlayedDay === dayNumber - 1) {
		s.current += 1;
	} else if (s.current > 0 && s.lastPlayedDay === dayNumber - 2 && jokerAvailableFor(s, dayNumber - 1)) {
		s.current += 1;
		s.jokerUsedDay = dayNumber - 1;
		jokerUsed = true;
	} else {
		s.current = 1;
	}
	s.longest = Math.max(s.longest, s.current);
	s.lastPlayedDay = dayNumber;
	return { streak: s, jokerUsed };
}
